import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import CardMedia from '@mui/material/CardMedia';
import Card from 'bento-ordering/menus/ui_components/Card';
import { getImageWithHeight } from 'bento-ordering/utils/images';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import MenuItemNameTypography from 'components/MenuItemNameTypography';

import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';

import ownCardState from 'helpers/ownState/DropShadowState';

const StyledCardMedia = styled(CardMedia)({
  display: 'flex',
  width: '20%'
});

const PriceText = styled(MenuItemNameTypography)({
  fontStyle: 'normal',
  fontSize: '14px',
  paddingTop: '4px'
});

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '10px 15px 10px 15px',
  justifyContent: 'space-between'
}));

const StyledGrid = styled(Grid)({
  height: '100%'
});

const TruncatedItemName = styled(MenuItemNameTypography, {
  shouldForwardProp: muiPropForwarding('hasImage')
})(({ hasImage }) => ({
  width: hasImage ? '125%' : '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

const StyledGridContainer = styled(Grid)(({ theme }) => {
  return {
    '&.MuiGrid-container': {
      height: '100%',
      justifyContent: 'space-between',
      backgroundColor: theme?.palette?.card?.background?.main
    }
  };
});

const MenuUpsellItemCard = ({
  name,
  image = {
    url: ''
  },
  price
}) => {
  const textContentGridStyles = image.url
    ? { lg: 8, md: 8, xs: 8 }
    : { xs: 12 };

  const resizedImage = getImageWithHeight(image.url, 520);

  return (
    <Card dataTestId="menu-page-item" ownState={ownCardState()}>
      <StyledGridContainer container>
        <StyledGrid item {...textContentGridStyles}>
          <StyledBox>
            <TruncatedItemName variant={MENU_ITEM_NAMES} hasImage={!!image.url}>
              {name}
            </TruncatedItemName>
            <PriceText variant={ITEM_DESCRIPTION_AND_PRICES}>
              {`$${price}`}
            </PriceText>
          </StyledBox>
        </StyledGrid>
        {image.url && (
          <StyledCardMedia alt={name} image={resizedImage} title={name} />
        )}
      </StyledGridContainer>
    </Card>
  );
};

MenuUpsellItemCard.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string
  }),
  price: PropTypes.string.isRequired
};

export default MenuUpsellItemCard;
